import coef from 'components/display/data/coefficients'

export function predictAgeFromFeature(value, coef) {
  let predictedAge = (value - coef.B0) / coef.B1
  if (predictedAge > 72) {
    predictedAge = 72
  } else if (predictedAge < 16) {
    predictedAge = 16
  }
  return predictedAge
}

export function predictAge(appData) {
  let years = 0
  let count = 0
  let keys = Object.keys(coef)
  for (const key of keys) {
    years +=
      coef[key].weight !== 0
        ? predictAgeFromFeature(appData.user.featureProfile[key], coef[key]) *
          coef[key].weight
        : 0
    count += coef[key].weight
  }
  return years / count
}

export function handlePredictAge(app) {
  app.user.predictedAge = Math.round(predictAge(app))
  return Promise.resolve(app)
}
